import { action, runInAction, makeObservable } from "mobx";
import { API } from "General/API";
import { projectsDataStore } from "Stores/ProjectsStore";
import { ObjectDataStore } from "./RESTStoreInstances/ObjectDataStore";
import { API_URL } from "General/APIEndpoints";

export class DisclaimerStore extends ObjectDataStore<API_DisclaimerData> {
  constructor() {
    super();

    makeObservable(this, {
      confirmDisclaimer: action.bound,
      setDisclaimer: action.bound,
    });
  }

  url() {
    return API_URL.DISCLAIMER.getDisclaimer(projectsDataStore.projectId);
  }

  async confirmDisclaimer() {
    try {
      await API.newData(API_URL.DISCLAIMER.agreeToDisclaimer(projectsDataStore.projectId, this.data.id), {});
      runInAction(() => {
        projectsDataStore.acceptDisclaimer();
      });
    } catch (err) {
      throw err;
    }
  }

  async setDisclaimer(values: API_DisclaimerData) {
    try {
      const url = API_URL.DISCLAIMER.getDisclaimer(projectsDataStore.projectId);
      // if disclaimer ID exists - make update request
      if (this.data.id) {
        await API.editData(url, values);
      } else {
        // otherwise do POST request
        await API.newData(url, { ...values, id: this.data.id });
      }
      runInAction(() => {
        this.data = { ...this.data, ...values };
      });
    } catch (err) {
      throw err;
    }
  }
}

export const disclaimerStore = new DisclaimerStore();
